import { Button } from 'foundations-components/transitional/components/Button';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SuccessScreen({
  demoPortalId,
  industry,
  onClose
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PanelBody, {
      "data-test-id": "demo-data-success-screen",
      children: /*#__PURE__*/_jsx(PanelSection, {
        children: /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "partnerDemoPortalUi.panel.success.title"
          }),
          help: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "partnerDemoPortalUi.panel.success.help",
            options: {
              industry: typeof industry === 'string' ? unescapedText(`partnerDemoPortalUi.industry.options.${industry}`) : ''
            }
          }),
          children: /*#__PURE__*/_jsx(Button, {
            marginBlockStart: "500",
            use: "primary",
            href: `${getFullUrl('app')}/global-home/${demoPortalId}`,
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "partnerDemoPortalUi.panel.actions.viewDemoAccount"
            })
          })
        })
      })
    }), /*#__PURE__*/_jsx(PanelFooter, {
      align: "right",
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: onClose,
        "data-test-id": "demo-data-success-close-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "partnerDemoPortalUi.panel.actions.close"
        })
      })
    })]
  });
}